import viewerStyles from './3dviewer-styles.min.css?raw';

const viewerStylesheet = new CSSStyleSheet();

if (typeof viewerStylesheet.replaceSync === 'function') {
  viewerStylesheet.replaceSync(viewerStyles);
}

export { viewerStylesheet };
